import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ReactGA from "react-ga4";
import { get } from "lodash";

import { routes, baseRoute, GA_trackId, stage } from "src/config";
import { useAuth } from "src/providers/Auth";
import { useActions } from "src/hooks/useActions";
import { getVerify } from "src/actions/auth";
import { getHasCanUseCoupon } from "src/actions/coupon";
import Loading from "src/components/Loading";

import logo from "src/assets/logo_white.png";
import couponListMainImg from "src/assets/kv.jpg";

import "./App.css";
import { preloadImages, storeUtm } from "./utils/method";

ReactGA.initialize(GA_trackId, {
  debug: stage === "local",
  titleCase: false,
});

function App() {
  const {
    auth: { accessToken, userId },
  } = useAuth();

  const [actionGetVerify, actionGetHasCanUseCoupon] = useActions([
    getVerify,
    getHasCanUseCoupon,
  ]);
  const [isFetched, setIsFetched] = useState(false);

  const checkVerify = async () => {
    const [verifyResp, hasCanUseCouponResp] = await Promise.all([
      actionGetVerify(userId),
      actionGetHasCanUseCoupon({ accessToken, userId }),
    ]);
    const qs = window.location.search;

    const location = window.location.pathname;

    if (!get(hasCanUseCouponResp, "data.data.result")) {
      if (location !== "/form") window.location.href = `${baseRoute}/form${qs}`;
      return;
    }

    if (!verifyResp) {
      if (location !== "/form") {
        window.location.href = `${baseRoute}/form${qs}`;
      }
    } else {
      if (["/form", "/"].includes(location)) {
        window.location.href = `${baseRoute}/couponList${qs}`;
      }
    }
  };

  useEffect(() => {
    async function init() {
      storeUtm();
      setIsFetched(false);
      if (userId) await checkVerify();
      await preloadImages([logo, couponListMainImg]);
      setIsFetched(true);
    }
    init();
  }, [userId]);

  // console.log("cicd1");
  if (!isFetched) return <Loading />;
  return (
    <div className="App">
      {userId && (
        <div className="App-content">
          <BrowserRouter>
            <Routes>
              {routes.map((routeItem) => {
                return <Route {...routeItem} />;
              })}
            </Routes>
          </BrowserRouter>
        </div>
      )}
    </div>
  );
}

export default App;
